import { api } from "../services/api";

/* Subida de imágenes y videos al servidor, compartida por los formularios de
 * eventos, sponsors y publicaciones. Los archivos quedan en temp hasta que se
 * guarda el formulario; el backend los mueve a su carpeta final. */

// espejo del límite de controllers/media (UploadLocal rechaza más de 10MB)
export const MAX_TAMANIO_ARCHIVO = 10 * 1024 * 1024;
export const MAX_TAMANIO_TEXTO = "10MB";

/* Sube los archivos y devuelve los items {url, type, format, public_id}.
 * Los que superan el tamaño se descartan y se informan en `rechazados`;
 * si la subida falla, lanza un Error con un mensaje para mostrar. */
export const subirArchivos = async (archivos) => {
  const lista = Array.from(archivos ?? []);
  const rechazados = lista.filter((f) => f.size > MAX_TAMANIO_ARCHIVO).map((f) => f.name);
  const validos = lista.filter((f) => f.size <= MAX_TAMANIO_ARCHIVO);
  if (!validos.length) return { items: [], rechazados };

  const formData = new FormData();
  validos.forEach((file) => formData.append("files", file));

  const response = await api.media.uploadLocal(formData);
  if (response.status !== "success") {
    throw new Error(response.message || "No se pudieron subir los archivos.");
  }

  const items = response.data.media.map((item) => ({
    url: item.url,
    type: item.type,
    format: item.format,
    public_id: item.public_id,
  }));
  return { items, rechazados };
};

/* Borra un archivo recién subido (en temp). Si ya pertenece a un evento o
 * publicación el backend no lo toca: lo borra al guardar. No falla: si no se
 * pudo borrar, el backend limpia al guardar igual. */
export const descartarArchivo = async (publicId) => {
  if (!publicId) return;
  try {
    await api.media.deleteLocal({ public_id: publicId });
  } catch (error) {
    console.error("Error al descartar el archivo:", error);
  }
};
